import { render } from "./SidebarEmpleadoComponent.vue?vue&type=template&id=6676fb62&scoped=true"
import script from "./SidebarEmpleadoComponent.vue?vue&type=script&lang=js"
export * from "./SidebarEmpleadoComponent.vue?vue&type=script&lang=js"

import "./SidebarEmpleadoComponent.vue?vue&type=style&index=0&id=6676fb62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6676fb62"]])

export default __exports__